export default function parseVendorConsent(config) {
    let newVendorConsent = {};
    let newObjectConsent = {};
    let newSpecialFeatureOptins = {};
    let newPurposeConsent = {};
    let newPurposeLegitimateInterest = {};

    if (config.vendorList) {
        for (let index = 0; index < config.vendorList.vendors.length; index++) {
            if (config.vendorList.vendors[index].legIntPurposes.length > 0) {
                if (config.static && config.static.objectConsent && (config.static.objectConsent[config.vendorList.vendors[index].id] === true || config.static.objectConsent[config.vendorList.vendors[index].id] === false)) {
                    newObjectConsent[config.vendorList.vendors[index].id] = config.static.objectConsent[config.vendorList.vendors[index].id];
                } else {
                    newObjectConsent[config.vendorList.vendors[index].id] = config.defaultObjectConsent === false ? config.defaultObjectConsent : true;
                }
            }

            if (config.static && config.static.vendorConsent && (config.static.vendorConsent[config.vendorList.vendors[index].id] === true || config.static.vendorConsent[config.vendorList.vendors[index].id] === false)) {
                newVendorConsent[config.vendorList.vendors[index].id] = config.static.vendorConsent[config.vendorList.vendors[index].id];
            } else {
                newVendorConsent[config.vendorList.vendors[index].id] = config.defaultConsent === false ? config.defaultConsent : true;
            }
        }

        for (let index = 0; index < config.vendorList.specialFeatures.length; index++) {
            if (config.static && config.static.specialFeatureOptins && (config.static.specialFeatureOptins[config.vendorList.specialFeatures[index].id] === true || config.static.specialFeatureOptins[config.vendorList.specialFeatures[index].id] === false)) {
                newSpecialFeatureOptins[config.vendorList.specialFeatures[index].id] = config.static.specialFeatureOptins[config.vendorList.specialFeatures[index].id];
            } else {
                newSpecialFeatureOptins[config.vendorList.specialFeatures[index].id] = config.defaultConsent === false ? config.defaultConsent : true;
            }
        }

        for (let index = 0; index < config.vendorList.purposes.length; index++) {
            if (config.static && config.static.purposeConsent && (config.static.purposeConsent[config.vendorList.purposes[index].id] === true || config.static.purposeConsent[config.vendorList.purposes[index].id] === false)) {
                newPurposeConsent[config.vendorList.purposes[index].id] = config.static.purposeConsent[config.vendorList.purposes[index].id];
            } else {
                newPurposeConsent[config.vendorList.purposes[index].id] = config.defaultConsent === false ? config.defaultConsent : true;
            }
            
            if (config.static && config.static.purposeLegitimateInterest && (config.static.purposeLegitimateInterest[config.vendorList.purposes[index].id] === true || config.static.purposeLegitimateInterest[config.vendorList.purposes[index].id] === false)) {
                newPurposeLegitimateInterest[config.vendorList.purposes[index].id] = config.static.purposeLegitimateInterest[config.vendorList.purposes[index].id];
            } else {
                newPurposeLegitimateInterest[config.vendorList.purposes[index].id] = config.defaultObjectConsent === false ? config.defaultObjectConsent : true;
            } 
        }

    }

    return {
        vendorConsent: newVendorConsent, 
        objectConsent: newObjectConsent, 
        specialFeatureOptins: newSpecialFeatureOptins, 
        purposeConsent: newPurposeConsent, 
        purposeLegitimateInterest: newPurposeLegitimateInterest
    };
}